import React, { useState, useRef, useEffect } from 'react';
import { connect } from 'react-redux';
import { setPublicKey } from '../../../api/profile/profile';
import { mnemonicGenerate, mnemonicValidate } from '@polkadot/util-crypto';
import { Keyring } from '@polkadot/api';
import { setProfile } from '../../../actions/profile';
import { errorMessageHandler } from '../../../utils/utils';

function MissingMnemonics({
    visible,
    onClose,
    onConfirm,
}) {

    const [mnemonics, setMnemonics] = useState(null);
    const [publicAddress, setPublicAddress] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(null);

    const modalRef = useRef(null);


    useEffect(() => {
        const modalElement = document.getElementById("confirmationMissingMnemonicsModal");
        if (!modalElement) return;

        const modal = new window.bootstrap.Modal(modalElement);
        if (visible) modal.show();
        else modal.hide();

        return () => modal.hide();
    }, [visible]);

    const onChangeMnemonics = (e) => {
        e.preventDefault?.();

        const value = e.target.value;

        if (mnemonicValidate(value)) {
            const keyring = new Keyring({
                type: 'sr25519',
                ss58Format: 42,
            });
            const newPair = keyring.addFromUri(value);

            setMnemonics(value);
            setPublicAddress(newPair.address);
        } else {
            setMnemonics(value);
            setPublicAddress(null);
        }
    };

    const submit = async () => {
        setIsLoading(true);
        try {
            await setPublicKey({ public_address: publicAddress });

            setIsError(null);
            setIsLoading(false);

            localStorage.setItem("showToast", "Wallet created successfully!");
            window.location.reload();
        } catch (e) {
            setIsError(errorMessageHandler(e));
            setIsLoading(false);
        }
    };

    const resetModalState = () => {
        setMnemonics("");
        setPublicAddress("");
        setIsLoading(false)
        setIsError(null)

    };

    return (
        <>

            <div
                className="modal fade"
                id="confirmationMissingMnemonicsModal"
                tabIndex="-1"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"

            >
                <div className="modal-dialog modal-dialog-centered modal-md">
                    <div className="modal-content">
                        <div className="modal-header align-items-start">
                            <h5 className="modal-title">
                                We have not confirmed your Public Address yet!
                            </h5>
                            <button
                                type="button"
                                className="btn-close m-0"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>

                        <div className="modal-body">
                            <p className="mb-4">
                                Please enter the mnemonics to associate the public key with your
                                account for future use.
                            </p>

                            <div className="mb-3">
                                <label className="form-label CeraMed d-block mb-1">
                                    Account Mnemonics
                                </label>

                                <textarea
                                    value={mnemonics || ""}
                                    style={{
                                        borderColor:
                                            !mnemonics
                                                ? ""
                                                : mnemonicValidate(mnemonics)
                                                    ? "green"
                                                    : "red"
                                    }}
                                    onChange={onChangeMnemonics}
                                    name="mnemonics"
                                    rows="4"
                                    className="form-control shadow-none"
                                    placeholder="Paste your mnemonics here"
                                ></textarea>

                                <p className="form-text mb-0">
                                    We are not storing your private key, this can be used
                                    one time for this transaction.
                                </p>
                            </div>

                            <button
                                className="btn BtnBorderBlack w-100 mb-3"
                                onClick={() =>
                                    onChangeMnemonics({
                                        target: { value: mnemonicGenerate() }
                                    })
                                }
                            >
                                Generate New Account Mnemonics
                            </button>
                        </div>

                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-outline-dark px-4 py-2"
                                data-bs-dismiss="modal"
                                onClick={() => {
                                    resetModalState();
                                    onClose?.();
                                }}
                            >
                                <i className="fas fa-times me-2"></i>
                                Cancel
                            </button>

                            <button
                                disabled={!mnemonicValidate(mnemonics) || isLoading}
                                onClick={submit}
                                type="button"
                                className="btn BtnBlack py-2 px-3 px-md-5"
                            >
                                {isError ? isError : "Confirm"}{" "}
                                {isLoading && (
                                    <i className="fas fa-asterisk fa-spin text-center" />
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

const mapStateToProps = (state) => ({
    public_address: state.Profile.profile.public_address,
    currentUser: state.Profile.profile,
    token: state.Auth.token
});

export default connect(mapStateToProps, { setProfile })(MissingMnemonics);
